import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const viTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Tên (viết thường, không có ký tự đặc biệt)',
    add: 'Thêm',
    allowedFileTypes: 'Các loại tệp được phép',
    allowedFileTypesDescription:
      'Hạn chế các loại tệp được phép (ví dụ: hình ảnh/*, ứng dụng/pdf). Để trống để cho phép tất cả các loại.',
    allowMultipleFiles: 'Cho phép nhiều tệp',
    amountInCents: 'Số tiền tính bằng xu',
    basePrice: 'Giá cơ sở',
    bcc: 'BCC',
    brand: 'Thương hiệu',
    cc: 'CC',
    checkboxPlural: 'Trường hộp kiểm',
    checkboxSingular: 'Hộp kiểm',
    checkedByDefault: 'Đã kiểm tra theo mặc định',
    chooseConfirmationType:
      'Chọn hiển thị thông báo trên trang hay chuyển hướng đến một trang khác sau khi họ gửi biểu mẫu.',
    condition: 'tình trạng',
    confirmationMessage: 'Tin nhắn xác nhận',
    confirmationType: 'Loại xác nhận',
    countryPlural: 'Trường Quốc gia',
    countrySingular: 'Quốc gia',
    creditCard: 'Thẻ tín dụng',
    customURL: 'URL tùy chỉnh',
    datePlural: 'Trường ngày',
    dateSingular: 'Ngày',
    defaultValue: 'Giá trị mặc định',
    divide: 'Chia',
    documentToLinkTo: 'Tài liệu để liên kết đến',
    doesNotEqual: 'Không bằng',
    emailFrom: 'Gửi email từ',
    emailPlural: 'Trường email',
    emailsDescription:
      'Gửi email tùy chỉnh khi biểu mẫu được gửi. Sử dụng danh sách được phân tách bằng dấu phẩy để gửi cùng một email cho nhiều người nhận. Để tham chiếu một giá trị từ biểu mẫu này, hãy bọc tên trường đó bằng dấu ngoặc nhọn đôi, tức là {{firstName}}. Bạn có thể sử dụng ký tự đại diện {{*}} để xuất tất cả dữ liệu và {{*:table}} để định dạng dữ liệu đó dưới dạng bảng HTML trong email.',
    emailSingular: 'Email',
    emailTo: 'Gửi email tới',
    equals: 'Bằng',
    field: 'trường',
    fields: 'Trường',
    fieldWidth: 'Độ rộng trường (phần trăm)',
    hasAnyValue: 'Có bất kỳ giá trị nào',
    internalLink: 'Liên kết nội bộ',
    label: 'Nhãn',
    maxFileSize: 'Kích thước tệp tối đa (byte)',
    maxFileSizeDescription: 'Kích thước tệp tối đa tính bằng byte. Để trống không có giới hạn.',
    message: 'Tin nhắn',
    messageDescription: 'Nhập nội dung cần gửi trong email này.',
    messagePlural: 'Khối tin nhắn',
    messageSingular: 'Tin nhắn',
    mimeType: 'Loại MIME',
    mimeTypePlural: 'Các loại MIME',
    mimeTypeSingular: 'Loại MIME',
    multiply: 'nhân',
    numberPlural: 'Trường số',
    numberSingular: 'Số',
    optionPlural: 'Tùy chọn',
    optionSingular: 'Tùy chọn',
    paymentFieldPlural: 'Trường thanh toán',
    paymentFieldSingular: 'Thanh toán',
    paymentProcessor: 'Bộ xử lý thanh toán',
    paymentStatus: 'Trạng thái',
    placeholder: 'Trình giữ chỗ',
    priceConditions: 'Điều kiện giá',
    priceConditionsPlural: 'Điều kiện giá',
    priceConditionsSingular: 'Điều kiện giá',
    radioOptions: 'Tùy chọn thuộc tính đài phát thanh',
    radioPlural: 'Trường vô tuyến',
    radioSingular: 'Đài phát thanh',
    redirect: 'Chuyển hướng',
    replyTo: 'Trả lời tới',
    required: 'Bắt buộc',
    selectOptions: 'Chọn Tùy chọn',
    selectPlural: 'Chọn trường',
    selectSingular: 'chọn',
    statePlural: 'Trường trạng thái',
    stateSingular: 'tiểu bang',
    staticValue: 'Giá trị tĩnh',
    subject: 'chủ đề',
    submitButton: 'Gửi nhãn nút',
    subtract: 'Trừ',
    textareaPlural: 'Trường văn bản',
    textareaSingular: 'Vùng văn bản',
    textPlural: 'Trường văn bản',
    textSingular: 'văn bản',
    title: 'Tiêu đề',
    token: 'mã thông báo',
    uploadCollection: 'Tải lên bộ sưu tập',
    uploadCollectionDescription: 'Chọn bộ sưu tập tải lên để lưu trữ tệp trong',
    uploadFieldPlural: 'Tải lên các trường',
    uploadFieldSingular: 'Tải lên',
    urlToRedirectTo: 'URL để chuyển hướng đến',
    value: 'Giá trị',
    valueOfField: 'Giá trị của trường',
    valueType: 'Loại giá trị',
  },
}

export const vi: PluginLanguage = {
  dateFNSKey: 'vi',
  translations: viTranslations,
}
